<template>
  <VConfirmation
    v-model="actionModel"
    class="row"
    :heading="actionHeadline"
    v-bind="$attrs"
    @confirm="onConfirm"
    @expand="$emit('expand')"
    @abort="$emit('abort')"
  >
    <template #prompt>
      <span v-html="promptText"></span>
    </template>
    <template v-if="hasOptionResetPromotionAndTrialStatus" #beforeContent>
      <VForm :form="form">
        <VCheckbox name="resetPromotionAndTrialStatus">{{ $t('substore.checkbox_resetPromotionAndTrialStatus') }}</VCheckbox>
      </VForm>
    </template>
  </VConfirmation>
</template>

<script>
import VConfirmation from '@/components/Confirmation';
import { initFields } from '@/utils/form';

export default {
  name: 'StockProductButtonConfirmationTerminate',

  components: {
    VConfirmation,
    VForm: () => import('@/components/Form/Form'),
    VCheckbox: () => import('@/components/Form/Checkbox'),
  },

  inheritAttrs: false,

  props: {
    action: {
      type: Object,
      required: false,
      default: null,
    },

    texts: {
      type: Object,
      required: true,
    },

    productOption: {
      type: Object,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      form: initFields({ name: 'resetPromotionAndTrialStatus' }),
    };
  },

  computed: {
    actionModel: {
      get() {
        return this.action;
      },
      set(v) {
        this.$emit('update:action', v);
      },
    },

    actionHeadline() {
      return this.actionModel?.headline;
    },

    promptText() {
      return this.texts.orderTerminationQuestion || this.$t('substore.prompt_termination');
    },

    hasOptionResetPromotionAndTrialStatus() {
      return this.productOption?.resetPromotionAndTrialStatusAllowed;
    },
  },

  methods: {
    onConfirm(params) {
      if (this.hasOptionResetPromotionAndTrialStatus && this.form.resetPromotionAndTrialStatus.value) params.name = 'terminateAndResetPromotionAndTrialStatus';
      this.$emit('confirm', params);
    },
  },
};
</script>
